/**
 * "This tab runs a bundle older than the backend." Two things detect it — the
 * version poll (`version-check.ts`) and the Convex "could not find public
 * function" rejection (`../errors/handle-mutation-error.ts`) — and one dialog
 * reacts to it, from anywhere in the tree. `handleMutationError` is a plain
 * function called from ~40 modules, so it cannot open a React dialog itself.
 *
 * The React side is `hooks/use-stale-bundle.ts`.
 */
let stale = false;
const listeners = new Set<() => void>();

/** Latching: a stale tab never becomes fresh again, only reloaded. */
export function markStaleBundle() {
  if (stale) return;
  stale = true;
  for (const listener of listeners) listener();
}

export function isStaleBundle() {
  return stale;
}

export function subscribeToStaleBundle(onChange: () => void) {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
}
